<template lang="pug">
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" @click="emitClick($event)">
		<defs>
			<filter id="zypnkuskia">
				<feColorMatrix in="SourceGraphic" values="0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"/>
			</filter>
		</defs>
		<g fill="none" fill-rule="evenodd">
			<g filter="url(#zypnkuskia)" transform="translate(-16 -19)">
				<g fill="#303030" transform="translate(16 19)">
					<rect width="20" height="2" rx="1"/>
					<rect width="20" height="2" y="8" rx="1"/>
					<rect width="20" height="2" y="16" rx="1"/>
				</g>
			</g>
		</g>
	</svg>
</template>

<style lang="stylus" scoped>

</style>

<script>
export default {
	methods:{
		emitClick(event){
			this.$emit('click', event)
		}
	}
}
</script>
